export const stdoutRegexp = {
    success: /^(.*)(\[\[F[023]B2\]\])$/,
    info_header: /^(.*)(\[\[F4B[37]\]\])$/,
    footer: /^(.*)(\[\[F0B5\]\])$/,
    warning_compData: /^(.*)(\[\[F0B[38]\]\])$/,
    warning2: /^(.*)(\[\[F3B4\]\])$/,
    telecommand: /^(.*)(\[\[F4B9\]\])$/,
    error: /^(.*)(\[\[F[037]B1\]\])$/,
    title: /^(.*)(\[\[F1B7\]\])$/
};
export function registerStdoutLanguage(monaco) {
    monaco.languages.register({ id: "stdoutLanguage" });
    monaco.languages.setMonarchTokensProvider("stdoutLanguage", {
        tokenizer: {
            root: [{ include: "@whitespace" }],
            comment: [
                [stdoutRegexp.success, ["success", "hidden"]],
                [stdoutRegexp.info_header, ["info", "hidden"]],
                [stdoutRegexp.footer, ["footer", "hidden"]],
                [stdoutRegexp.warning_compData, ["warning", "hidden"]],
                [stdoutRegexp.warning2, ["warning", "hidden"]],
                [stdoutRegexp.telecommand, ["warning", "hidden"]],
                [stdoutRegexp.error, ["error", "hidden"]],
                [stdoutRegexp.title, ["error", "hidden"]],
                [/^\s?!\* .*$/, "info"],
                [/^\s?!\*\* .*$/, "error"]
            ],
            whitespace: [
                [/^.*$/, "", "@comment"]
            ]
        }
    });
    monaco.editor.defineTheme("stdoutTheme", {
        base: "vs",
        inherit: false,
        rules: [
            { token: "success", foreground: "00bf07" },
            { token: "info", foreground: "0000DD" },
            { token: "footer", foreground: "cf3476" },
            { token: "warning", foreground: "ffa500" },
            { token: "error", foreground: "ff0000" },
            { token: "hidden", foreground: "ffffff" }
        ]
    });
    return monaco;
}
//# sourceMappingURL=stdoutLanguage.js.map